/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Note_Read_Card_AriaInputs */

const en_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Read note: ${i?.title}`)
};

const ar_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اقرأ الملاحظة: ${i?.title}`)
};

const bn_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`নোট পড়ুন: ${i?.title}`)
};

const de_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notiz lesen: ${i?.title}`)
};

const es_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leer nota: ${i?.title}`)
};

const fr_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lire la remarque : ${i?.title}`)
};

const pt_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leia a nota: ${i?.title}`)
};

const zh_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`阅读注释：${i?.title}`)
};

const tr_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notu okuyun: ${i?.title}`)
};

const ru_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Прочитать примечание: ${i?.title}`)
};

const pl_note_read_card_aria = /** @type {(inputs: Note_Read_Card_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Przeczytaj notatkę: ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Read note: {title}" |
*
* @param {Note_Read_Card_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const note_read_card_aria = /** @type {((inputs: Note_Read_Card_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Read_Card_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_note_read_card_aria(inputs)
	if (locale === "bn") return bn_note_read_card_aria(inputs)
	if (locale === "de") return de_note_read_card_aria(inputs)
	if (locale === "es") return es_note_read_card_aria(inputs)
	if (locale === "fr") return fr_note_read_card_aria(inputs)
	if (locale === "pt") return pt_note_read_card_aria(inputs)
	if (locale === "zh") return zh_note_read_card_aria(inputs)
	if (locale === "tr") return tr_note_read_card_aria(inputs)
	if (locale === "ru") return ru_note_read_card_aria(inputs)
	if (locale === "pl") return pl_note_read_card_aria(inputs)
	return en_note_read_card_aria(inputs)
});